import { ContainerModule } from 'inversify';
import { PracticeStateMachine } from './practice-state-machine';

export const practiceSessionDomainModule = new ContainerModule((bind) => {
  bind(PracticeStateMachine).toSelf()
});
